import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (query) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_PROCESS_LIST',
    url: '',
  });

  useEffect(() => {
    if (query) {
      let url = '/api/system/authority?get_user_process_tree=1';
      exec(url);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [query]);

  return [data || [], isRequestSuccessed];
});
